import { render } from "./gsgg.vue?vue&type=template&id=44d266eb&scoped=true&ts=true"
import script from "./gsgg.vue?vue&type=script&lang=ts"
export * from "./gsgg.vue?vue&type=script&lang=ts"

import "./gsgg.vue?vue&type=style&index=0&id=44d266eb&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d266eb"]])

export default __exports__